document.querySelectorAll('[data-slider-id="icon-and-text"]').forEach(function (swiper) {
  const iconAndTextSwiper = new Swiper(swiper, {
    slidesPerView: 1.25,
    spaceBetween: 15,
    autoplay: true,
    loop: false,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    breakpoints: {
      1024: {
        slidesPerView: 4,
        spaceBetween: 30,
      },
      768: {
        slidesPerView: 2.25,
        spaceBetween: 30,
      },
      480: {
        slidesPerView: 1.25,
        spaceBetween: 15,
      },
    },
  });
});
